module.exports = __webpack_public_path__ + "static/media/landing-page-bg.d56230c8.svg";